
import { Component, Prop, Mixins } from 'vue-property-decorator';
import { VuetifyMixin, BAIconsMixin, AppHostnameMixin, StringsMixin, AthleteRoutingMixin, AthleteProfileMixin, CoachRoutingMixin, PaginatedTableMixin } from '@/mixins';
import { DataTableHeader } from 'vuetify';
import { RepositoryQuery, QueryOptions, PaginatedResponse } from '@/../types/interfaces';
import { ScoutingReportModel, ScoutingReportModelEx } from '@/models/scoutingReport/ScoutingReportModel';
import { PartialAthleteProfile, PartialCoachProfile, PartialTeam } from '@/models';
import { PartialOrganization } from '@/models/organization/OrganizationModel';
import { SportModel } from '@/models/sport';
import { athleteApi } from '@/api/AthleteApi';
import { scoutingReportApi } from '@/api/ScoutingReportApi';
import { ObjectCache } from '@/helpers';
import ScoutingReportBrief from '@/components/profile/athlete/ScoutingReportBrief.vue';

@Component({
	components: {
		ScoutingReportBrief,
	}
})
export default class AthleteScoutingReportsHistory extends Mixins(AppHostnameMixin, BAIconsMixin, StringsMixin, VuetifyMixin, PaginatedTableMixin, AthleteProfileMixin, AthleteRoutingMixin, CoachRoutingMixin){
	@Prop({ type: Boolean }) showIncomplete;
	scoutingReportsDetails: Array<ScoutingReportModelEx> = [];

	mounted() {
		this.tableOptions.sortBy = ['submitted','createdAt'];
		this.tableOptions.sortDesc = [true, true];
		this.localForagePersistFields = [['search', ''],['tableOptions.page', 1],['tableOptions.itemsPerPage', 25]];
	}

	athletesCache: ObjectCache<PartialAthleteProfile> = new ObjectCache<PartialAthleteProfile>();
	coachesCache: ObjectCache<PartialCoachProfile> = new ObjectCache<PartialCoachProfile>();
	teamsCache: ObjectCache<PartialTeam> = new ObjectCache<PartialTeam>();
	orgsCache: ObjectCache<PartialOrganization> = new ObjectCache<PartialOrganization>();
	sportsCache: ObjectCache<SportModel> = new ObjectCache<SportModel>();
	
	isScoutingReportsLoading: boolean = false;
	isScoutingReportsLoaded: boolean = false;
	async loadDetails(reports: Array<ScoutingReportModel>): Promise<Array<ScoutingReportModelEx>> {
		return Promise.all(reports.map(async(report) => {
			const ex = new ScoutingReportModelEx();
			await ex.fromReport(report, this.athletesCache, this.coachesCache, this.teamsCache, this.orgsCache, this.sportsCache);
			return ex;
		}));
	}
	async loadTable() {
		this.isScoutingReportsLoading = true;
		this.isScoutingReportsLoaded = false;
		const query: RepositoryQuery<ScoutingReportModel> = this.TableQuery<ScoutingReportModel>(this.search, ['gameDetails.coachId', 'notes', 'scoutingReport.gameDetails.teamName']);
		query.$match = {...query.$match, ...{ 'athleteId': this.athleteId }};
		if( !this.showIncomplete ) query.$match = {...query.$match, ...{ 'submitted': true }};
		const options: QueryOptions = this.TableQueryOptions;
		const response: PaginatedResponse<ScoutingReportModel> = await scoutingReportApi.queryAll(query, options);
		this.scoutingReportsDetails = await this.loadDetails(response.docs);
		this.dataItemsCount = response.total;
		this.isScoutingReportsLoaded = true;
		this.isScoutingReportsLoading = false;
	}

	get TableLoading(): boolean {
		return this.isScoutingReportsLoading;
	}
	get PageLoading(): boolean {
		return this.TableLoading || this.isLoadingAthleteProfile;
	}

	get TableHeaders(): Array<DataTableHeader<any>> {
		let headers: Array<DataTableHeader<any>> = [
			{ text: 'Date', value: 'createdAt', sortable: false },
			{ text: 'Coach', value: 'coach', sortable: false },
			{ text: 'Team', value: 'team', sortable: false },
			{ text: 'Location', value: 'location', sortable: false },
			{ text: 'Score', value: 'performance', sortable: false, width:'90', align:'center' },
			{ text: 'Potential', value: 'potential', sortable: false, width:'90', align:'center' },
		];
		if( this.IsLargeScreen ) {
			headers.push({text: '', value: 'actions', sortable: false });
			headers.push({text: '', value: 'data-table-expand', sortable: false});
		}
		return headers;
	}
	
	updatingFeatured: boolean = false;
	get HasScoutingReports(): boolean {
		return this.IsNotEmpty(this.scoutingReportsDetails);
	}

	isFeatured(report: ScoutingReportModel): boolean {
		return( this.athleteProfile.featuredScoutingReport === report.id );
	}
	async onSetFeatured(report: ScoutingReportModel) {
        this.updatingFeatured = true;
        this.athleteProfile.featuredScoutingReport = report.id;
        await athleteApi.save(this.athleteProfile);
		this.$emit('setFeatured');
        this.updatingFeatured = false;
	}

	goToScoutingReportView(reportId: string) {
		if( this.CoachAppActive || this.AdminAppActive ) {
			this.gotoCoachViewScoutingReport(reportId);
		} else {
			this.goToScoutingReport(reportId);
		}
	}
}
